module.exports = __webpack_public_path__ + "img/farewell_1.10bda0a4.jpg";